export const environment = {
  production: false,
  hmr: true,
  // baseUrl:'http://192.168.20.202:8000', // smile pc
  // baseUrl:'https://ikooapidev.elitetraveltech.in',
  // baseUrl:'http://192.168.20.245:8001', // Harinder pc
  // baseUrl:'http://172.168.1.32:8001/', // Harinder pc
  // baseUrl:'http://192.168.20.201:8000', //  pc
  // baseUrl : 'http://127.0.0.1:8000',
  baseUrl: 'https://api.dev.ikooworld.com',
  enkey: 'vinay@4471#74@0#2.8@kumar',
  defaultLanguage: 'Label',
  supportedLanguages: ['Label', 'TMSA'],
};
